<template lang="pug">
v-card(flat)
  v-card-text
    v-form(ref="form", v-model="valid", @submit="register")
      v-text-field(
        v-model="email",
        label="Email",
        prepend-icon="mdi-email",
        :rules="[rules.isEmail, rules.required]",
        required
      )

      v-text-field(
        type="password",
        v-model="password",
        label="Password",
        prepend-icon="mdi-form-textbox-password",
        :rules="[rules.hasUppercase, rules.hasLowercase, rules.hasNumber, rules.min, rules.hasSpecial, rules.required]",
        required
      )

      v-row
        v-col(sm="6")
          v-text-field(
            v-model="firstName",
            label="Given name",
            :rules="[rules.required]",
            required
          )

        v-col(sm="6")
          v-text-field(
            v-model="lastName",
            label="Family name",
            :rules="[rules.required]",
            required
          )

      v-row(align="center center", class="mt-n9 ml-1")
        v-checkbox(v-model="acceptedTerms")
          template(v-slot:label)
            div
              div
                span I have read and accepted the
                a.ml-1(
                target="_blank",
                href="https://drive.google.com/file/d/1xLZ1ItnIEsiXjrpDrvIZI0g_urKdbQp9/view?usp=sharing",
                @click.stop
                ) Terms and Conditions
              div
                span(class="mr-1") and
                a(
                href="https://drive.google.com/file/d/1YgEG1pBCy0iCq82q97LD3nULGjpGT0Jz/view?usp=sharing",
                @click.stop,
                target="_blank"
                ) Privacy Policy
      v-btn(
        block,
        color="primary",
        @click="register",
        :loading="loading",
        :disabled="!valid || !acceptedTerms"
      ) register
</template>

<script>
/* eslint-disable no-useless-escape */
export default {
  name: "registration",

  mounted() {
    if (this.$route.params.company_id) {
      this.company_id = parseInt(this.$route.params.company_id);
    }
  },

  data: () => ({
    rules: {
      required: (v) => !!v || "Required",
      hasUppercase: (v) => /[A-Z]/.test(v) || "Upper case characters required",
      hasLowercase: (v) => /[a-z]/.test(v) || "Lower case characters required",
      hasNumber: (v) => /[0-9]/.test(v) || "At least one number",
      hasSpecial: (v) =>
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v) ||
        "At least one special !@#$%^&*()_+-=[]{};':\"\\|,.<>/?~",
      isEmail: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      min: (v) => (!!v && v.length >= 8) || "Min 8 characters",
    },
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    valid: false,
    loading: false,
    company_id: 0,
    acceptedTerms: false
  }),

  methods: {
    register() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        // let role = "employer";
        // if (this.company_id !== 0) role = "candidate";
        const role = this.company_id !== 0 ? "candidate" : "employer";
        this.$auth
          .register({
            data: {
              email: this.email,
              password: this.password,
              first_name: this.firstName,
              last_name: this.lastName,
              role: role,
              company_id: this.company_id,
            },
          })
          .then(() => {
            if (this.company_id !== 0) {
              this.$auth.login({
                data: {
                  email: this.email,
                  password: this.password,
                },
              }).then(() => {
                this.$store.dispatch("flows/refreshFlowsList");
              });
            } else {
              this.loading = false;
              this.$emit("success", "Verify your email");
              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$emit("error", e.response.data.Error);
          });
      }
    },
  },
};
</script>
